import { render, staticRenderFns } from "./ScriptCreate.vue?vue&type=template&id=5137d2f5&scoped=true"
import script from "./ScriptCreate.vue?vue&type=script&lang=js"
export * from "./ScriptCreate.vue?vue&type=script&lang=js"
import style0 from "./ScriptCreate.vue?vue&type=style&index=0&id=5137d2f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5137d2f5",
  null
  
)

export default component.exports